/* eslint-disable */
import React, { useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { MdPhotoLibrary } from 'react-icons/md';
import AccountInfoLayout from '../../Component/AccountInfoLayout';
import AgentCard from '../../Component/AgentCard/AgentCard';
import Footer from '../../Component/Footer';
import Header from '../../Component/Header';
import Tabs from '../../Component/Tabs';
import classes from './FollowedAgents.module.css';
// import { _agentData } from '../AgentOrCompany';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import CompanyCard from '../../Component/CompanyCard/CompanyCard';
import { Loader } from '../../Component/Loader';
import NoData from '../../Component/NoData/NoData';
import PaginationComponent from '../../Component/PaginationComponent';
import { recordsLimit } from '../../config/apiUrl';
import { useLazyGetApiQuery, usePostApiMutation } from '../../store/apiSlice/apiSlice';
import { updateUser } from '../../store/auth/authSlice';

const FollowedAgents = () => {
  const { t } = useTranslation('followedAgentsOrCompany');
  const tabsData = [
    { icon: <MdPhotoLibrary />, text: t('followedAgents'), id: '1' },
    { icon: <MdPhotoLibrary />, text: t('followedCompany'), id: '2' }
  ];
  const { user } = useSelector((state) => state?.authReducer);

  const [tabValue, setTabValue] = useState(tabsData[0]);
  const [page, setPage] = useState(1);
  const [checkboxArray, setCheckboxArray] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [getApiFunc, { data: renderDataNew, isLoading: loadingNew, isFetching }] =
    useLazyGetApiQuery();
  const [deleteApiFunc] = usePostApiMutation();

  const deleteApi = async (allUsers = []) => {
    if (renderDataNew?.data?.length == 0) return;

    const deleteResponse = await deleteApiFunc({
      url: `users/unFollowMultiple`,
      data: {
        ids: allUsers?.length > 0 ? allUsers : checkboxArray
      },
      method: 'DELETE',
      tag: `myFollowing`
    });
    if (deleteResponse?.data) {
      dispatch(updateUser(deleteResponse?.data?.data));
      setCheckboxArray([]);
      toast.success(
        `${
          allUsers?.length > 0
            ? tabValue?.id == '1'
              ? t('toast.allAgent')
              : t('toast.allCompanies')
            : tabValue?.id == '1'
            ? t('toast.agent')
            : t('toast.company')
        }  ${t('toast.deletedSuccessfully')}`
      );
      getData(tabValue?.id == '1' ? 'agent' : 'company');
    }
  };

  const getData = async (type = 'agent') => {
    await getApiFunc({
      url: `users/getMyFollowing?type=${type}&page=${page}&limit=${recordsLimit}`,
      tag: `myFollowing`
    });
  };
  useEffect(() => {
    getData();
  }, [page]);

  return (
    <div className="page_bg">
      <Header containerClass="customContainer" />
      <AccountInfoLayout>
        <Tabs
          className={classes.tab_main}
          tabClass={classes.tab_class_main}
          value={tabValue}
          setValue={(e) => {
            if (isFetching || loadingNew) return;
            setCheckboxArray([]);
            setTabValue(tabsData.find((item) => item.id == e.id));
            getData(e?.id == '1' ? 'agent' : 'company');
            setPage(1);
          }}
          tabsData={tabsData}
        />
        <div className={classes.delete_div}>
          <div
            style={{
              display: 'flex'
            }}>
            <p>{`${t('showing')} ${renderDataNew?.data?.length ?? 0}-${
              renderDataNew?.totalRecords
            } ${tabValue?.id == 1 ? t('agent') : t('company')} `}</p>
            <p
              onClick={() =>
                deleteApi(tabValue?.id == 1 ? user?.agentFollowing : user?.companyFollowing)
              }
              className="c-p"
              style={{
                color: renderDataNew?.data?.length == 0 && '#ccc'
              }}>
              {t('deleteAll')}
            </p>
            <p
              style={{
                color: checkboxArray?.length == 0 && '#ccc'
              }}
              onClick={() => {
                if (checkboxArray?.length == 0) {
                  return toast.error(
                    `${t('toast.error')} ${
                      tabValue?.id == '1' ? t('toast.agent') : t('toast.company')
                    }`
                  );
                }
                deleteApi();
              }}
              className="c-p">
              {t('deleteSelected')}
            </p>
          </div>
          {/* <div className={classes.sort_div}>
            <p>Sort by:</p>

            <div
              style={{
                marginRight: '20px'
              }}>
              <DropDown classNamePrefix={'dropDownMain'} placeholder={'Featured'} />
            </div>
            <DropDown classNamePrefix={'dropDownMain'} placeholder={'Featured'} />
          </div> */}
        </div>
        <div className={classes?.contentDiv}>
          <Row className="">
            {loadingNew ? (
              <Loader />
            ) : renderDataNew?.data?.length == 0 ? (
              <NoData
                text={`${tabValue?.id == '1' ? t('noFollowedAgents') : t('noFollowedCompany')}`}
              />
            ) : (
              renderDataNew?.data?.map((e, i) => {
                return (
                  <Col key={i} xl={4} lg={6} md={6}>
                    <Form.Check
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        marginBottom: '10px'
                      }}
                      checked={checkboxArray.includes(e?._id)}
                      onClick={() => {
                        if (checkboxArray.includes(e?._id)) {
                          setCheckboxArray(checkboxArray.filter((item) => item != e?._id));
                        } else {
                          setCheckboxArray([...checkboxArray, e?._id]);
                        }
                      }}
                      name="group1"
                      type={'checkbox'}
                      id={`inline-checkbox-1`}
                    />

                    {tabValue?.id == '1' ? (
                      <AgentCard
                        data={e}
                        index={i}
                        onClick={(agentData) => navigate(`/agents/${agentData?.slug}`)}
                      />
                    ) : (
                      <CompanyCard
                        data={e}
                        index={i}
                        onClick={(agentData) => navigate(`/company/${agentData?.slug}`)}
                      />
                    )}
                  </Col>
                );
              })
            )}

            {renderDataNew?.data?.length > 0 && (
              <div
                style={{ marginTop: '20px', marginBottom: '20px' }}
                className={`${[classes.pagination, 'jCenter'].join(' ')}`}>
                <PaginationComponent
                  totalPages={Math.ceil(renderDataNew?.totalRecords / recordsLimit)}
                  currentPage={page}
                  setCurrentPage={(e) => {
                    // getAgentsOrCompany(e);
                    setPage(e);
                  }}
                />
              </div>
            )}
          </Row>
        </div>
      </AccountInfoLayout>
      <Footer />
    </div>
  );
};

export default FollowedAgents;
